export default {
  metadata: {
    version: '2.0.0',
    id: 'badge-status-2.0.0',
    name: 'JDSBadgeV2Status'
  },
  hierarchy: {
    'outer-container': [
      {
        container: [
          {
            'status-container': ['status-icon']
          },
          'label-jds-text'
        ]
      }
    ]
  },
  base: {
    'outer-container': {
      'background-color': '{primaryBackground}',
      'border-radius': '{b_8}'
    },
    container: {
      'flex-direction': '{b_0}',
      'justify-content': '{b_1}',
      'align-items': '{b_2}',
      gap: '{custom_17}'
    },
    'status-container': {
      hidden: false,
      show: true,
      'flex-direction': '{b_4}',
      'justify-content': '{b_5}',
      'align-items': '{b_6}',
      size: '{m}',
      'border-radius': '{b_8}',
      'background-color': '{b_9}'
    },
    'status-icon': {
      value: 'ic_message_send',
      color: '{b_10}',
      size: '{base}'
    },
    'label-jds-text': {
      'font-family': '{text_152}',
      color: '{text_60}',
      'font-size': '{text_151}',
      'line-height': '{text_153}',
      'letter-spacing': '{text_154}',
      'font-weight': '{text_155}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}',
      hidden: true
    }
  },
  variant: {
    kind: {
      dot: {
        'status-icon': {
          hidden: true
        }
      },
      label: {
        'outer-container': {
          'background-color': '{global.transparent}'
        },
        'status-container': {
          hidden: true
        },
        'label-jds-text': {
          hidden: false
        }
      },
      'dot-label': {
        'outer-container': {
          'background-color': '{global.transparent}'
        },
        container: {
          'padding-top': '{custom_4}',
          'padding-bottom': '{custom_4}'
        },
        'status-container': {
          size: '{custom_24}'
        },
        'status-icon': {
          hidden: true
        },
        'label-jds-text': {
          hidden: false
        }
      },
      'icon-label': {
        'outer-container': {
          'background-color': '{global.transparent}'
        },
        container: {
          'padding-top': '{custom_4}',
          'padding-bottom': '{custom_4}'
        },
        'status-container': {
          size: '{custom_24}'
        },
        'status-icon': {
          size: '{xs}'
        },
        'label-jds-text': {
          hidden: false
        }
      },
      'label-container': {
        'outer-container': {
          'border-radius': '{small}'
        },
        container: {
          'border-radius': '{small}',
          'padding-left': '{xs}',
          'padding-right': '{xs}',
          'padding-top': '{custom_4}',
          'padding-bottom': '{custom_4}'
        },
        'status-container': {
          hidden: true
        },
        'label-jds-text': {
          hidden: false
        }
      },
      'dot-label-container': {
        'outer-container': {
          'border-radius': '{small}'
        },
        container: {
          'border-radius': '{small}',
          'padding-left': '{xxs}',
          'padding-right': '{xs}',
          'padding-top': '{custom_4}',
          'padding-bottom': '{custom_4}'
        },
        'status-container': {
          size: '{custom_24}'
        },
        'status-icon': {
          hidden: true
        },
        'label-jds-text': {
          hidden: false
        }
      },
      'icon-label-container': {
        'outer-container': {
          'border-radius': '{small}'
        },
        container: {
          'border-radius': '{small}',
          'padding-left': '{xxs}',
          'padding-right': '{xs}',
          'padding-top': '{custom_4}',
          'padding-bottom': '{custom_4}'
        },
        'status-container': {
          size: '{custom_24}'
        },
        'status-icon': {
          size: '{xs}'
        },
        'label-jds-text': {
          hidden: false
        }
      }
    },
    size: {
      'xtra-small': {
        'status-container': {
          size: '{xs}'
        },
        'status-icon': {
          size: '{xxs}'
        },
        'label-jds-text': {
          'font-family': '{text_172}',
          'font-size': '{text_171}',
          'line-height': '{text_173}',
          'letter-spacing': '{text_174}',
          'font-weight': '{text_175}'
        }
      },
      small: {
        'status-container': {
          size: '{s}'
        },
        'status-icon': {
          size: '{xs}'
        },
        'label-jds-text': {
          'font-family': '{text_172}',
          'font-size': '{text_171}',
          'line-height': '{text_173}',
          'letter-spacing': '{text_174}',
          'font-weight': '{text_175}'
        }
      },
      medium: {
        'status-container': {
          size: '{base}'
        },
        'status-icon': {
          size: '{s}'
        },
        'label-jds-text': {
          'font-family': '{text_172}',
          'font-size': '{text_171}',
          'line-height': '{text_173}',
          'letter-spacing': '{text_174}',
          'font-weight': '{text_175}'
        }
      },
      large: {
        'status-container': {
          size: '{custom_18}'
        },
        'status-icon': {
          size: '{custom_24}'
        },
        'label-jds-text': {
          'font-family': '{text_172}',
          'font-size': '{text_171}',
          'line-height': '{text_173}',
          'letter-spacing': '{text_174}',
          'font-weight': '{text_175}'
        }
      },
      'xtra-xtra-large': {
        'status-container': {
          size: '{custom_3}'
        },
        'status-icon': {
          size: '{custom_18}'
        }
      },
      'xtra-xtra-xtra-large': {
        'status-container': {
          size: '{l}'
        },
        'status-icon': {
          size: '{m}'
        },
        'label-jds-text': {
          'font-family': '{text_137}',
          'font-size': '{text_136}',
          'line-height': '{text_138}',
          'letter-spacing': '{text_139}',
          'font-weight': '{text_140}'
        }
      },
      'xtra-xtra-xtra-xtra-large': {
        'status-container': {
          size: '{xl}'
        },
        'status-icon': {
          size: '{l}'
        },
        'label-jds-text': {
          'font-family': '{text_107}',
          'font-size': '{text_106}',
          'line-height': '{text_108}',
          'letter-spacing': '{text_109}',
          'font-weight': '{text_110}'
        }
      }
    },
    status: {
      error: {
        'status-container': {
          'background-color': '{b_30}'
        },
        'status-icon': {
          value: 'ic_close'
        },
        'label-jds-text': {
          color: '{text_54}'
        }
      },
      warning: {
        'status-container': {
          'background-color': '{b_31}'
        },
        'status-icon': {
          value: 'ic_exclamation'
        },
        'label-jds-text': {
          color: '{text_57}'
        }
      },
      disabled: {
        container: {
          disabled: true
        },
        'status-container': {
          'background-color': '{b_32}'
        },
        'status-icon': {
          value: 'ic_close'
        },
        'label-jds-text': {
          color: '{text_22}'
        }
      }
    },
    border: {
      true: {
        'outer-container': {
          'padding-top': '{custom_4}',
          'padding-bottom': '{custom_4}',
          'padding-left': '{custom_4}',
          'padding-right': '{custom_4}'
        }
      }
    }
  },
  combination: [
    {
      'dot-label': {
        'xtra-small': {
          container: {
            'padding-top': '{custom_5}',
            'padding-bottom': '{custom_5}'
          },
          'status-container': {
            size: '{custom_19}'
          }
        },
        small: {
          container: {
            'padding-top': '{custom_5}',
            'padding-bottom': '{custom_5}'
          },
          'status-container': {
            size: '{custom_19}'
          }
        },
        medium: {
          container: {
            'padding-top': '{custom_5}',
            'padding-bottom': '{custom_5}'
          },
          'status-container': {
            size: '{custom_19}'
          }
        },
        large: {
          'status-container': {
            size: '{custom_24}'
          }
        },
        'xtra-large': {
          'status-container': {
            size: '{custom_24}'
          }
        },
        'xtra-xtra-large': {
          container: {
            'padding-top': '{xxs}',
            'padding-bottom': '{xxs}'
          },
          'status-container': {
            size: '{custom_24}'
          }
        },
        'xtra-xtra-xtra-large': {
          container: {
            'padding-top': '{xxs}',
            'padding-bottom': '{xxs}'
          },
          'status-container': {
            size: '{custom_22}'
          }
        },
        'xtra-xtra-xtra-xtra-large': {
          container: {
            gap: '{custom_18}',
            'padding-top': '{xxs}',
            'padding-bottom': '{xxs}'
          },
          'status-container': {
            size: '{custom_30}'
          }
        }
      },
      'icon-label': {
        'xtra-small': {
          container: {
            'padding-top': '{custom_5}',
            'padding-bottom': '{custom_5}'
          },
          'status-container': {
            size: '{custom_19}'
          },
          'status-icon': {
            size: '{custom_15}'
          }
        },
        small: {
          container: {
            'padding-top': '{custom_5}',
            'padding-bottom': '{custom_5}'
          },
          'status-container': {
            size: '{custom_19}'
          },
          'status-icon': {
            size: '{custom_15}'
          }
        },
        medium: {
          container: {
            'padding-top': '{custom_5}',
            'padding-bottom': '{custom_5}'
          },
          'status-container': {
            size: '{custom_19}'
          },
          'status-icon': {
            size: '{custom_15}'
          }
        },
        large: {
          'status-container': {
            size: '{custom_24}'
          },
          'status-icon': {
            size: '{xs}'
          }
        },
        'xtra-large': {
          'status-container': {
            size: '{custom_24}'
          },
          'status-icon': {
            size: '{xs}'
          }
        },
        'xtra-xtra-large': {
          container: {
            'padding-top': '{xxs}',
            'padding-bottom': '{xxs}'
          },
          'status-container': {
            size: '{custom_24}'
          },
          'status-icon': {
            size: '{xs}'
          }
        },
        'xtra-xtra-xtra-large': {
          container: {
            'padding-top': '{xxs}',
            'padding-bottom': '{xxs}'
          },
          'status-container': {
            size: '{custom_22}'
          },
          'status-icon': {
            size: '{custom_19}'
          }
        },
        'xtra-xtra-xtra-xtra-large': {
          container: {
            gap: '{custom_18}',
            'padding-top': '{xxs}',
            'padding-bottom': '{xxs}'
          },
          'status-container': {
            size: '{custom_30}'
          },
          'status-icon': {
            size: '{custom_24}'
          }
        }
      },
      'label-container': {
        'xtra-small': {
          container: {
            'padding-left': '{xxs}',
            'padding-right': '{xxs}',
            'padding-top': '{custom_5}',
            'padding-bottom': '{custom_5}'
          }
        },
        small: {
          container: {
            'padding-left': '{xxs}',
            'padding-right': '{xxs}',
            'padding-top': '{custom_5}',
            'padding-bottom': '{custom_5}'
          }
        },
        medium: {
          container: {
            'padding-left': '{xxs}',
            'padding-right': '{xxs}',
            'padding-top': '{custom_5}',
            'padding-bottom': '{custom_5}'
          }
        },
        'xtra-xtra-large': {
          container: {
            'padding-top': '{xxs}',
            'padding-bottom': '{xxs}'
          }
        },
        'xtra-xtra-xtra-large': {
          'outer-container': {
            'border-radius': '{medium}'
          },
          container: {
            'border-radius': '{medium}',
            'padding-top': '{xxs}',
            'padding-bottom': '{xxs}'
          }
        },
        'xtra-xtra-xtra-xtra-large': {
          'outer-container': {
            'border-radius': '{medium}'
          },
          container: {
            'border-radius': '{medium}',
            'padding-left': '{s}',
            'padding-right': '{s}',
            'padding-top': '{xxs}',
            'padding-bottom': '{xxs}'
          }
        }
      },
      'dot-label-container': {
        'xtra-small': {
          container: {
            'padding-left': '{xxs}',
            'padding-right': '{xxs}',
            'padding-top': '{custom_5}',
            'padding-bottom': '{custom_5}'
          },
          'status-container': {
            size: '{custom_19}'
          }
        },
        small: {
          container: {
            'padding-left': '{xxs}',
            'padding-right': '{xxs}',
            'padding-top': '{custom_5}',
            'padding-bottom': '{custom_5}'
          },
          'status-container': {
            size: '{custom_19}'
          }
        },
        medium: {
          container: {
            'padding-left': '{xxs}',
            'padding-right': '{xxs}',
            'padding-top': '{custom_5}',
            'padding-bottom': '{custom_5}'
          },
          'status-container': {
            size: '{custom_19}'
          }
        },
        large: {
          'status-container': {
            size: '{custom_24}'
          }
        },
        'xtra-large': {
          'status-container': {
            size: '{custom_24}'
          }
        },
        'xtra-xtra-large': {
          container: {
            'padding-left': '{xs}',
            'padding-top': '{xxs}',
            'padding-bottom': '{xxs}'
          },
          'status-container': {
            size: '{custom_24}'
          }
        },
        'xtra-xtra-xtra-large': {
          'outer-container': {
            'border-radius': '{medium}'
          },
          container: {
            'border-radius': '{medium}',
            'padding-left': '{xs}',
            'padding-top': '{xxs}',
            'padding-bottom': '{xxs}'
          },
          'status-container': {
            size: '{custom_22}'
          }
        },
        'xtra-xtra-xtra-xtra-large': {
          'outer-container': {
            'border-radius': '{medium}'
          },
          container: {
            'border-radius': '{medium}',
            'padding-left': '{xs}',
            'padding-right': '{s}',
            'padding-top': '{xxs}',
            'padding-bottom': '{xxs}',
            gap: '{custom_18}'
          },
          'status-container': {
            size: '{custom_30}'
          }
        }
      },
      'icon-label-container': {
        'xtra-small': {
          container: {
            'padding-left': '{xxs}',
            'padding-right': '{xxs}',
            'padding-top': '{custom_5}',
            'padding-bottom': '{custom_5}'
          },
          'status-container': {
            size: '{custom_19}'
          },
          'status-icon': {
            size: '{custom_15}'
          }
        },
        small: {
          container: {
            'padding-left': '{xxs}',
            'padding-right': '{xxs}',
            'padding-top': '{custom_5}',
            'padding-bottom': '{custom_5}'
          },
          'status-container': {
            size: '{custom_19}'
          },
          'status-icon': {
            size: '{custom_15}'
          }
        },
        medium: {
          container: {
            'padding-left': '{xxs}',
            'padding-right': '{xxs}',
            'padding-top': '{custom_5}',
            'padding-bottom': '{custom_5}'
          },
          'status-container': {
            size: '{custom_19}'
          },
          'status-icon': {
            size: '{custom_15}'
          }
        },
        large: {
          'status-container': {
            size: '{custom_24}'
          },
          'status-icon': {
            size: '{xs}'
          }
        },
        'xtra-large': {
          'status-container': {
            size: '{custom_24}'
          },
          'status-icon': {
            size: '{xs}'
          }
        },
        'xtra-xtra-large': {
          container: {
            'padding-left': '{xs}',
            'padding-top': '{xxs}',
            'padding-bottom': '{xxs}'
          },
          'status-container': {
            size: '{custom_24}'
          },
          'status-icon': {
            size: '{xs}'
          }
        },
        'xtra-xtra-xtra-large': {
          'outer-container': {
            'border-radius': '{medium}'
          },
          container: {
            'border-radius': '{medium}',
            'padding-left': '{xs}',
            'padding-top': '{xxs}',
            'padding-bottom': '{xxs}'
          },
          'status-container': {
            size: '{custom_22}'
          },
          'status-icon': {
            size: '{custom_19}'
          }
        },
        'xtra-xtra-xtra-xtra-large': {
          'outer-container': {
            'border-radius': '{medium}'
          },
          container: {
            'border-radius': '{medium}',
            'padding-left': '{xs}',
            'padding-right': '{s}',
            'padding-top': '{xxs}',
            'padding-bottom': '{xxs}',
            gap: '{custom_18}'
          },
          'status-container': {
            size: '{custom_30}'
          },
          'status-icon': {
            size: '{custom_24}'
          }
        }
      }
    },
    {
      'label-container': {
        success: {
          container: {
            'background-color': '{b_61}'
          },
          'label-jds-text': {
            color: '{text_62}'
          }
        },
        error: {
          container: {
            'background-color': '{b_62}'
          },
          'label-jds-text': {
            color: '{text_62}'
          }
        },
        warning: {
          container: {
            'background-color': '{b_63}'
          },
          'label-jds-text': {
            color: '{text_62}'
          }
        },
        disabled: {
          container: {
            'background-color': '{b_64}'
          },
          'label-jds-text': {
            color: '{text_62}'
          }
        }
      },
      'dot-label-container': {
        success: {
          container: {
            'background-color': '{b_65}'
          },
          'status-container': {
            'background-color': '{b_66}'
          },
          'label-jds-text': {
            color: '{text_62}'
          }
        },
        error: {
          container: {
            'background-color': '{b_67}'
          },
          'status-container': {
            'background-color': '{b_68}'
          },
          'label-jds-text': {
            color: '{text_62}'
          }
        },
        warning: {
          container: {
            'background-color': '{b_69}'
          },
          'status-container': {
            'background-color': '{b_70}'
          },
          'label-jds-text': {
            color: '{text_62}'
          }
        },
        disabled: {
          container: {
            'background-color': '{b_71}'
          },
          'status-container': {
            'background-color': '{b_72}'
          },
          'label-jds-text': {
            color: '{text_62}'
          }
        }
      },
      'icon-label-container': {
        success: {
          container: {
            'background-color': '{b_73}'
          },
          'status-container': {
            'background-color': '{b_74}'
          },
          'status-icon': {
            color: '{b_75}'
          },
          'label-jds-text': {
            color: '{text_62}'
          }
        },
        error: {
          container: {
            'background-color': '{b_76}'
          },
          'status-container': {
            'background-color': '{b_77}'
          },
          'status-icon': {
            color: '{b_78}'
          },
          'label-jds-text': {
            color: '{text_62}'
          }
        },
        warning: {
          container: {
            'background-color': '{b_79}'
          },
          'status-container': {
            'background-color': '{b_80}'
          },
          'status-icon': {
            color: '{b_81}'
          },
          'label-jds-text': {
            color: '{text_62}'
          }
        },
        disabled: {
          container: {
            'background-color': '{b_82}'
          },
          'status-container': {
            'background-color': '{b_83}'
          },
          'status-icon': {
            color: '{b_84}'
          },
          'label-jds-text': {
            color: '{text_62}'
          }
        }
      }
    },
    {
      true: {
        label: {
          'outer-container': {
            'padding-top': '{custom_5}',
            'padding-bottom': '{custom_5}',
            'padding-left': '{custom_5}',
            'padding-right': '{custom_5}'
          }
        },
        'dot-label': {
          'outer-container': {
            'padding-top': '{custom_5}',
            'padding-bottom': '{custom_5}',
            'padding-left': '{custom_5}',
            'padding-right': '{custom_5}'
          }
        },
        'icon-label': {
          'outer-container': {
            'padding-top': '{custom_5}',
            'padding-bottom': '{custom_5}',
            'padding-left': '{custom_5}',
            'padding-right': '{custom_5}'
          }
        },
        'dot-label-container': {
          'outer-container': {
            'padding-top': '{custom_5}',
            'padding-bottom': '{custom_5}',
            'padding-left': '{custom_5}',
            'padding-right': '{custom_5}'
          }
        },
        'icon-label-container': {
          'outer-container': {
            'padding-top': '{custom_5}',
            'padding-bottom': '{custom_5}',
            'padding-left': '{custom_5}',
            'padding-right': '{custom_5}'
          }
        }
      }
    },
    {
      true: {
        dot: {
          'xtra-small': {
            'outer-container': {
              'padding-top': '{custom_1}',
              'padding-bottom': '{custom_1}',
              'padding-left': '{custom_1}',
              'padding-right': '{custom_1}'
            }
          },
          small: {
            'outer-container': {
              'padding-top': '{custom_1}',
              'padding-bottom': '{custom_1}',
              'padding-left': '{custom_1}',
              'padding-right': '{custom_1}'
            }
          },
          'xtra-xtra-large': {
            'outer-container': {
              'padding-top': '{custom_16}',
              'padding-bottom': '{custom_16}',
              'padding-left': '{custom_16}',
              'padding-right': '{custom_16}'
            }
          },
          'xtra-xtra-xtra-large': {
            'outer-container': {
              'padding-top': '{custom_16}',
              'padding-bottom': '{custom_16}',
              'padding-left': '{custom_16}',
              'padding-right': '{custom_16}'
            }
          },
          'xtra-xtra-xtra-xtra-large': {
            'outer-container': {
              'padding-top': '{xxs}',
              'padding-bottom': '{xxs}',
              'padding-left': '{xxs}',
              'padding-right': '{xxs}'
            }
          }
        },
        icon: {
          'xtra-small': {
            'outer-container': {
              'padding-top': '{custom_1}',
              'padding-bottom': '{custom_1}',
              'padding-left': '{custom_1}',
              'padding-right': '{custom_1}'
            }
          },
          small: {
            'outer-container': {
              'padding-top': '{custom_1}',
              'padding-bottom': '{custom_1}',
              'padding-left': '{custom_1}',
              'padding-right': '{custom_1}'
            }
          },
          'xtra-xtra-large': {
            'outer-container': {
              'padding-top': '{custom_16}',
              'padding-bottom': '{custom_16}',
              'padding-left': '{custom_16}',
              'padding-right': '{custom_16}'
            }
          },
          'xtra-xtra-xtra-large': {
            'outer-container': {
              'padding-top': '{custom_16}',
              'padding-bottom': '{custom_16}',
              'padding-left': '{custom_16}',
              'padding-right': '{custom_16}'
            }
          },
          'xtra-xtra-xtra-xtra-large': {
            'outer-container': {
              'padding-top': '{xxs}',
              'padding-bottom': '{xxs}',
              'padding-left': '{xxs}',
              'padding-right': '{xxs}'
            }
          }
        },
        'label-container': {
          large: {
            'outer-container': {
              'padding-top': '{custom_16}',
              'padding-bottom': '{custom_16}',
              'padding-left': '{custom_16}',
              'padding-right': '{custom_16}'
            }
          },
          'xtra-large': {
            'outer-container': {
              'padding-top': '{custom_16}',
              'padding-bottom': '{custom_16}',
              'padding-left': '{custom_16}',
              'padding-right': '{custom_16}'
            }
          },
          'xtra-xtra-large': {
            'outer-container': {
              'padding-top': '{custom_16}',
              'padding-bottom': '{custom_16}',
              'padding-left': '{custom_16}',
              'padding-right': '{custom_16}'
            }
          },
          'xtra-xtra-xtra-large': {
            'outer-container': {
              'padding-top': '{custom_16}',
              'padding-bottom': '{custom_16}',
              'padding-left': '{custom_16}',
              'padding-right': '{custom_16}'
            }
          },
          'xtra-xtra-xtra-xtra-large': {
            'outer-container': {
              'padding-top': '{xxs}',
              'padding-bottom': '{xxs}',
              'padding-left': '{xxs}',
              'padding-right': '{xxs}'
            }
          }
        }
      }
    }
  ],
  combination_config: [
    ['kind', 'size'],
    ['kind', 'status'],
    ['border', 'kind'],
    ['border', 'kind', 'size']
  ],
  api: {
    config: {
      kind: {
        values: [
          'icon',
          'dot',
          'label',
          'dot-label',
          'icon-label',
          'label-container',
          'dot-label-container',
          'icon-label-container'
        ]
      },
      size: {
        values: [
          'xtra-large',
          'small',
          'xtra-small',
          'medium',
          'large',
          'xtra-xtra-large',
          'xtra-xtra-xtra-large',
          'xtra-xtra-xtra-xtra-large'
        ]
      },
      status: {
        values: ['success', 'error', 'warning', 'disabled']
      },
      border: {
        values: [false, true]
      }
    },
    data: {
      'label-jds-text': {
        value: {
          type: 'string',
          name: 'label'
        }
      }
    },
    a11y: {
      container: {
        properties: {
          'aria-label': {
            name: 'ariaLabel',
            prop: 'label'
          },
          'aria-describedby': {
            name: 'ariaDescribedby',
            platform: 'web,ios'
          }
        }
      }
    }
  }
};
